<div
  class="preclinical flex flex-col w-full bg-background-tertiary"
  [class.expanded-view]="isExpanded"
  [class.gap-6]="!isExpanded"
  [class.py-6]="!isExpanded"
  [class.min-h-screen]="!isExpanded"
  [class.h-screen]="isExpanded"
  [class.p-0]="isExpanded"
>
  <div
    class="header-section flex flex-col"
    [class.gap-6]="!isExpanded"
    [class.px-8]="isExpanded"
    [class.py-6]="isExpanded"
    [class.gap-3]="isExpanded"
  >
    <div class="flex flex-col gap-2">
      <h3 class="text-2xl font-bold text-brand-tertiary m-0">
        Trazabilidad de Muestras
      </h3>
      <p class="text-sm text-text-secondary m-0">
        Consulta el historial completo de cada muestra y sus cambios de estado.
      </p>
    </div>

    <!-- Metrics Dashboard - HU69-923100 -->
    <div class="flex flex-col gap-3">
      <!-- Totals Section -->
      <div class="flex flex-col gap-1">
        <span class="text-xs font-semibold text-text-tertiary uppercase"
          >Totales</span
        >
        <app-metrics-dashboard [metrics]="totalMetrics()" />
      </div>

      <!-- Sample Status Section -->
      <div class="flex flex-col gap-1">
        <span class="text-xs font-semibold text-text-tertiary uppercase"
          >Por Estado de Muestra</span
        >
        <app-metrics-dashboard [metrics]="sampleStatusMetrics()" />
      </div>

      <!-- Technology Section -->
      <div class="flex flex-col gap-1">
        <span class="text-xs font-semibold text-text-tertiary uppercase"
          >Por Tecnología</span
        >
        <app-metrics-dashboard [metrics]="technologyMetrics()" />
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="flex justify-between items-center gap-4 flex-wrap">
        <div class="flex gap-4">
          <app-button
            label="Exportar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="openExportModal()"
          >
          </app-button>
          <app-button
            label="Filtrar"
            leftIcon="icon-filtro"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFilterSidebar()"
          >
          </app-button>
          <app-button
            label="Buscar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleSearchControls()"
          >
          </app-button>
          <app-button
            label="Inmovilizar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFrozenColumnsSidebar()"
          >
          </app-button>
        </div>

        <button
          (click)="toggleExpansion()"
          class="w-10 h-10 min-w-10 min-h-10 border-none bg-transparent cursor-pointer p-0 flex-shrink-0"
          [class.icon-expandir-vista]="!isExpanded"
          [class.icon-contraer-vista]="isExpanded"
          [attr.aria-label]="isExpanded ? 'Contraer vista' : 'Expandir vista'"
          type="button"
        ></button>
      </div>

      @if (showSearchControls()) {
        <div class="search-controls-container animate-fade-in">
          <app-search-controls
            [searchFieldOptions]="searchFieldOptions"
            (searchExecuted)="handleSearch($event)"
            (clear)="handleClearSearch()"
          ></app-search-controls>
        </div>
      }

      @if (hasActiveFilters) {
        <app-active-filters
          [filterCriteria]="currentFilterCriteria"
          (clearFilters)="clearFilters()"
        ></app-active-filters>
      }
    </div>
  </div>

  <div
    class="flex flex-col table-container min-h-0"
    [class.flex-1]="isExpanded"
    [class.overflow-hidden]="isExpanded"
  >
    <app-table
      [items]="samples()"
      [visibleColumns]="visibleColumnsComputed()"
      [frozenColumns]="frozenColumnsInOrder()"
      [tableName]="'Trazabilidad'"
      [tableActions]="tableActions"
      [showCheckboxes]="false"
      [itemIdField]="'caseNumber'"
      [actionsPosition]="'left'"
    >
    </app-table>

    <app-paginator
      [totalRegister]="totalRecords()"
      (getData)="onPageChange($event)"
    >
    </app-paginator>
  </div>
</div>

<app-frozen-columns-sidebar
  [columns]="availableColumns"
  [isOpen]="isFrozenSidebarOpen"
  (closeSidebar)="closeFrozenColumnsSidebar()"
>
</app-frozen-columns-sidebar>

<app-filter-sidebar
  [isOpen]="isFilterSidebarOpen"
  [hiddenFilters]="['region', 'site', 'reprocessCause', 'examType', 'sampleStatus', 'sampleType']"
  [filterOptionsService]="getFilterOptionsService()"
  [currentFilters]="currentFilterCriteria"
  (closeSidebar)="closeFilterSidebar()"
  (applyFilters)="handleApplyFilters($event)"
>
</app-filter-sidebar>

<!-- Version History Modal -->
@if (isHistoryModalOpen() && selectedCase()) {
  <app-version-history-modal
    [caseItem]="selectedCase()!"
    [historyEntries]="historyEntries()"
    [isLoadingHistory]="isHistoryLoading()"
    (closeModal)="closeHistoryModal()"
  ></app-version-history-modal>
}

<!-- Prioritization Modal -->
@if (isPrioritizationModalOpen() && prioritizationCase()) {
  <app-prioritization-modal
    [caseItem]="prioritizationCase()!"
    [isSaving]="isPrioritizationSaving()"
    (closeModal)="closePrioritizationModal()"
    (save)="handleSavePrioritization($event)"
  ></app-prioritization-modal>
}

<!-- Export Confirmation Modal -->
<app-export-confirmation-modal
  [isOpen]="isExportModalOpen()"
  [state]="exportModalState()"
  (confirm)="handleExportConfirm()"
  (closeModal)="closeExportModal()"
></app-export-confirmation-modal>

<app-toast></app-toast>
